import { Component, inject, input, signal } from '@angular/core';
import { LocalizationPipe } from '@abp/ng.core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IModalContent } from '../zn-modal-wrapper/interfaces/IModalContent';

@Component({
  selector: 'lib-stepper-completion-message-modal',
  standalone: true,
  imports: [LocalizationPipe],
  template: '<p>{{ message() | abpLocalization }}</p>',
})
export class StepperCompletionMessageModal implements IModalContent {
  message = input('Default message');
  showIcon = input(false);
  canSave = signal(true);

  private readonly activeModal = inject(NgbActiveModal);

  confirm(): void {
    this.activeModal.close(true);
  }

  dismiss(): void {
    this.activeModal.close(false);
  }
}
